<script lang="ts">
  import PermissionCheckBox from './PermissionCheckBox.svelte';
  import { getFormContext } from '../forms/FormProviderCore.svelte';

  const { values, setFieldValue } = getFormContext();

  function handleSetPermission(permission, value) {
    const negPermission = '~' + permission;
    if (value == null) {
      setFieldValue(
        'permissions',
        $values.permissions.filter(y => y != permission && y != negPermission)
      );
    } else {
      setFieldValue('permissions', [
        ...$values.permissions.filter(y => y != permission && y != negPermission),
        value ? permission : negPermission,
      ]);
    }
  }
</script>

<PermissionCheckBox
  label="All permissions"
  permission="*"
  permissions={$values.permissions}
  basePermissions={$values.basePermissions}
  onSetPermission={handleSetPermission}
/>

<div class="ml-4">
  <PermissionCheckBox
    label="All connections"
    permission="all-connections"
    permissions={$values.permissions}
    basePermissions={$values.basePermissions}
    onSetPermission={handleSetPermission}
  />

  <PermissionCheckBox
    label="Internal storage"
    permission="internal-storage"
    permissions={$values.permissions}
    basePermissions={$values.basePermissions}
    onSetPermission={handleSetPermission}
  />

  <PermissionCheckBox
    label="Change settings"
    permission="settings/change"
    permissions={$values.permissions}
    basePermissions={$values.basePermissions}
    onSetPermission={handleSetPermission}
  />

  <PermissionCheckBox
    label="Install plugins"
    permission="plugins/install"
    permissions={$values.permissions}
    basePermissions={$values.basePermissions}
    onSetPermission={handleSetPermission}
  />

  <PermissionCheckBox
    label="Administration"
    permission="admin/*"
    permissions={$values.permissions}
    basePermissions={$values.basePermissions}
    onSetPermission={handleSetPermission}
  />

  <div class="ml-4">
    <PermissionCheckBox
      label="Authentication"
      permission="admin/auth"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />
    <PermissionCheckBox
      label="Connections"
      permission="admin/connections"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />
    <PermissionCheckBox
      label="Users"
      permission="admin/users"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />
    <PermissionCheckBox
      label="Roles"
      permission="admin/roles"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />
    <PermissionCheckBox
      label="Set license"
      permission="admin/license"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />
    <PermissionCheckBox
      label="Settings"
      permission="admin/settings"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />
    <PermissionCheckBox
      label="Audit log"
      permission="admin/auditlog"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />
  </div>

  <PermissionCheckBox
    label="Database operations"
    permission="dbops/*"
    permissions={$values.permissions}
    basePermissions={$values.basePermissions}
    onSetPermission={handleSetPermission}
  />
  <div class="ml-4">
    <PermissionCheckBox
      label="SQL templates"
      permission="dbops/sql-template/*"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="SQL generator"
      permission="dbops/sql-generator"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="SQL dump"
      permission="dbops/sql-dump/*"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />
    <div class="ml-4">
      <PermissionCheckBox
        label="Import SQL dump"
        permission="dbops/sql-dump/import"
        permissions={$values.permissions}
        basePermissions={$values.basePermissions}
        onSetPermission={handleSetPermission}
      />

      <PermissionCheckBox
        label="Export SQL dump"
        permission="dbops/sql-dump/export"
        permissions={$values.permissions}
        basePermissions={$values.basePermissions}
        onSetPermission={handleSetPermission}
      />
    </div>

    <PermissionCheckBox
      label="Run SQL query"
      permission="dbops/query"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="Import data"
      permission="dbops/import"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="Export data"
      permission="dbops/export"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="View charts"
      permission="dbops/charts"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="Database profiler"
      permission="dbops/profiler"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="Create database"
      permission="dbops/createdb"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="Drop database"
      permission="dbops/dropdb"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="Database model operations"
      permission="dbops/model/*"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <div class="ml-4">
      <PermissionCheckBox
        label="View database model (diagrams, JSON)"
        permission="dbops/model/view"
        permissions={$values.permissions}
        basePermissions={$values.basePermissions}
        onSetPermission={handleSetPermission}
      />

      <PermissionCheckBox
        label="Edit database model (create/change tables, views, etc.)"
        permission="dbops/model/edit"
        permissions={$values.permissions}
        basePermissions={$values.basePermissions}
        onSetPermission={handleSetPermission}
      />

      <PermissionCheckBox
        label="Compare database models"
        permission="dbops/model/compare"
        permissions={$values.permissions}
        basePermissions={$values.basePermissions}
        onSetPermission={handleSetPermission}
      />
    </div>

    <PermissionCheckBox
      label="Table operations"
      permission="dbops/table/*"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />
    <div class="ml-4">
      <PermissionCheckBox
        label="Rename table"
        permission="dbops/table/rename"
        permissions={$values.permissions}
        basePermissions={$values.basePermissions}
        onSetPermission={handleSetPermission}
      />
      <PermissionCheckBox
        label="Truncate table"
        permission="dbops/table/truncate"
        permissions={$values.permissions}
        basePermissions={$values.basePermissions}
        onSetPermission={handleSetPermission}
      />
      <PermissionCheckBox
        label="Create table backup"
        permission="dbops/table/backup"
        permissions={$values.permissions}
        basePermissions={$values.basePermissions}
        onSetPermission={handleSetPermission}
      />
    </div>
  </div>

  <PermissionCheckBox
    label="Widgets"
    permission="widgets/*"
    permissions={$values.permissions}
    basePermissions={$values.basePermissions}
    onSetPermission={handleSetPermission}
  />

  <div class="ml-4">
    <PermissionCheckBox
      label="Database widget"
      permission="widgets/database"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="File widget"
      permission="widgets/file"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="History widget"
      permission="widgets/history"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="Archive widget"
      permission="widgets/archive"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="Plugins widget"
      permission="widgets/plugins"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="Cell data widget"
      permission="widgets/cell-data"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="Application widget"
      permission="widgets/app"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />

    <PermissionCheckBox
      label="Administration widget"
      permission="widgets/admin"
      permissions={$values.permissions}
      basePermissions={$values.basePermissions}
      onSetPermission={handleSetPermission}
    />
  </div>
</div>
